import React from "react";

import styles from "./ErrorFallback.module.css";

/**
 * Rendered by the root Sentry.ErrorBoundary when a render crashes.
 * @param {{ eventId?: string | null }} props - Sentry event id, shown so support can find the exact error.
 */
const ErrorFallback = ({ eventId }) => (
  <div className={styles.page}>
    <div className={styles.card}>
      <span className={styles.iconWrap}>
        <svg
          className={styles.icon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7.5v5.5" />
          <circle cx="12" cy="16.6" r="0.7" fill="currentColor" stroke="none" />
        </svg>
      </span>

      <h1 className={styles.title}>Something went wrong</h1>
      <p className={styles.message}>
        This page ran into an unexpected error. Refreshing usually fixes it, and nothing you saved is lost.
      </p>

      <button type="button" className={styles.button} onClick={() => window.location.reload()}>
        Refresh page
      </button>

      {eventId && (
        <p className={styles.reference}>
          Reference ID
          <span className={styles.code}>{eventId}</span>
        </p>
      )}
    </div>
  </div>
);

export default ErrorFallback;
